import React from 'react';

/** Quanti pixel verso il basso bastano per chiudere. */
const SOGLIA = 80;

/**
 * UN PANNELLO DAL BASSO SI CHIUDE ANCHE TRASCINANDOLO GIU', come sul
 * telefono ci si aspetta: si prende dalla maniglia (o dal titolo) e lo si
 * tira. Oltre SOGLIA si chiude, prima torna al suo posto.
 *
 * Restituisce [rif, presa]: `rif` va sul pannello che si sposta, `presa` sulla
 * parte da cui lo si prende. La presa ha `touch-action: none` nel CSS, se no
 * il telefono scorre la pagina invece di spostare il pannello. Un tocco su un
 * pulsante o un collegamento dentro la presa (la X) resta un tocco. Col mouse
 * non si trascina: dal computer tirare il titolo serve a selezionarlo.
 */
export default function useTrascinaGiu(onChiudi) {
  const rif = React.useRef(null);
  const da = React.useRef(null);
  const quanto = React.useRef(0);

  const sposta = (dy) => {
    const el = rif.current;
    if (!el) return;
    el.style.transform = dy ? `translateY(${dy}px)` : '';
    el.style.transition = dy ? 'none' : '';
  };
  const lascia = (chiudi) => {
    if (da.current === null) return;
    da.current = null;
    const via = chiudi && quanto.current > SOGLIA;
    quanto.current = 0;
    sposta(0);
    if (via) onChiudi();
  };

  const presa = {
    onPointerDown: (e) => {
      if (e.pointerType === 'mouse' || e.button > 0 || e.target.closest('button, a, input')) return;
      da.current = e.clientY;
      quanto.current = 0;
      /* Il dito resta della presa anche uscendo da lei; se il browser non lo concede, si trascina lo stesso. */
      try { e.currentTarget.setPointerCapture(e.pointerId); } catch (_) { /* niente cattura */ }
    },
    onPointerMove: (e) => {
      if (da.current === null) return;
      quanto.current = Math.max(0, e.clientY - da.current);
      sposta(quanto.current);
    },
    onPointerUp: () => lascia(true),
    onPointerCancel: () => lascia(false),
  };
  return [rif, presa];
}
